export default __webpack_public_path__ + "static/media/CNo.92-5.d41c2091.jpg";